import { connect } from 'react-redux';
import { Routes, Route, useSearchParams } from 'react-router-dom';
import AssetList from './adms/AssetList';
import AssetCard from './adms/AssetCard';
import DocsList from './docs/DocList';
import DocCard from './docs/DocCard';
import EMDHistoryList from './emd/HistoryList';
import EMDHistoryCard from './emd/HistoryCard';
import EMDCard from './emd/EMDCard';
import IEPCard from './iep/IEPCard';
import XSDViewerProxy from './xsd/XSDViewerProxy';
import LinkerCard from './linker/LinkerCard';
import ConceptSchemeList from './skos/ConceptSchemeList';
import ConceptSchemeCard from './skos/ConceptSchemeCard';
import ValuesVocabsList from './vocabs/ValuesVocabsList';
import IndividualCard from './vocabs/IndividualCard';
import withRouter, {withRouterWithHighlight} from '../withRouter';
import SubjectList from './subject/SubjectList';
import { OwlRepository, RdfTriplet } from '../redux';
import AdminInterfaceLanding from './admin/AdminInterfaceLanding';
import SubjectCard from './subject/SubjectCard';
import SKSAOntology from './catalog/SKSAOntology';
import SKSACatalogList from './catalog/SKSACatalogList';
import SKSACatalogCard from './catalog/SKSACatalogCard';
import NamespaceList from './admin/NamespaceList';
import SettingsAction from '../redux/SettingsActions';

const RDFS_LABEL = 'http://www.w3.org/2000/01/rdf-schema#label';

//Представление списка элементов ADMS каталога
//Передаётся:
//  1. описания adms каталога 
//  3. метод dispatch и navigate. Первый для операций загрузки отдельных элементов, второй для навигации
export const AssetListViewBase = withRouter(connect(
  (state, props) => {
    const { vadms, vset, vselected } = state;
    return ({
      ...vadms, 
      vselected,
      isSignedIn: vset.isSignedIn, 
      lang: vset.lang,
      inGroup: vset.inGroup
    })
  },
  dispatch => ({
    onRefreshList(actions, conditions){
      //console.log("containers.js onRefreshList(actions, conditions)", conditions);
      //Для ADMS actions является AdmsRepository
      return dispatch(actions.loadAssets(conditions));
    },
    
    onChangeConditions (actions, conditions) {
      if (actions) 
        return dispatch(actions.CONDITIONS(conditions));
    },

    //Поиск по наименование (с учётом уже наложенных условий отбора)
    //Для SPARQL это contains(?dsn, "убл") strStarts(?dsn, "Д")
    onNameSearch (actions, pattern, conditions) {
      if (actions) { 
        const c = conditions.filter(item => !((item.predicate=="http://www.w3.org/2000/01/rdf-schema#label")&&(item.operator=="contains")));
        const filter = (!pattern)? c : c.concat({predicate: "http://www.w3.org/2000/01/rdf-schema#label", operator: "contains", value: pattern, alias:"dsn", label:pattern});
        //console.log("onNameSearch (actions, pattern, conditions)", pattern, conditions, c, filter);
        return dispatch(actions.CONDITIONS(filter)); //loadAssets(filter));
      };
    },

    //Поиск по алфавите (с учётом уже наложенных условий отбора)
    //Для SPARQL strStarts(?dsn, "Д")
    onAlphabetSearch(actions, pattern, conditions) {
      if (actions) {
        const c = conditions.filter(item => !((item.predicate=="http://www.w3.org/2000/01/rdf-schema#label")&&(item.operator=="strStarts")));
        //Текущее условие отбора по алфавиту
        const l = conditions.filter(item => ((item.predicate=="http://www.w3.org/2000/01/rdf-schema#label")&&(item.operator=="strStarts")));
        //Есть ли в условии такая же буква
        const hasPattern  = (l.length <1)? false: Array.isArray(l[0].value)? l[0].value.includes(pattern): l[0].value==pattern;
        //Есть условие - удалить букву из списка, нет - добавить
        const value = (hasPattern)?
            (Array.isArray(l[0].value))? l[0].value.filter(char => char!=pattern):""
          :  (l.length <1)? pattern: (Array.isArray(l[0].value))? l[0].value.concat(pattern):[l[0].value, pattern];
        const label = (Array.isArray(value))? value.join(", "): value;
        //Проверим, что условие пусто (т.е. "отжали все буквы")
        const isEmpty = !value || (value == "") || (Array.isArray(value) && (value.length==0))
        const filter = (isEmpty)? c : c.concat({predicate: "http://www.w3.org/2000/01/rdf-schema#label", operator: "strStarts", value, alias:"dsn", label});
        //console.log("onAlphabetSearch (actions, pattern, conditions)", pattern, conditions, c, filter);
        return dispatch(actions.CONDITIONS(filter)); //loadAssets(filter));
      };
    },

    //Связывает актив c каталогом
    onLinkAsset(action, catalog, asset){
      return dispatch(action.linkAsset(catalog, asset));
    }
  })
)(AssetList));

export const AssetListSelection = withRouter(connect(
  null,
  dispatch => ({
  })
)(AssetListViewBase));

export const AssetListView = withRouterWithHighlight(connect(
  null,
  (dispatch, ownProps) => ({
    onSelected (IRI, actions, navigate){
      const getBaseRoutePath = ownProps.getBaseRoutePath;
      //console.log("containers.js onSelected", ownProps, IRI, actions, IRI.startsWith("http://hbz.local/adms/pie#"));
      if (IRI.toUpperCase().lastIndexOf("EMD")==(IRI.length-3)){
        navigate("/viewemd/"+encodeURIComponent(IRI));
        return;
      }      
      if (IRI.startsWith("http://hbz.local/adms/pie#") || IRI.startsWith("http://hbz.local/adms/eip#")){
        navigate("/vieweip/"+encodeURIComponent(IRI));
        return;
      }
      if (getBaseRoutePath) {
        navigate(getBaseRoutePath("adms/" + encodeURIComponent(IRI)));
      } else {
        navigate("/adms/" + encodeURIComponent(IRI));
      }      
    },

    onAddElement (actions, catalog, iri, type, label, lang){
      return dispatch(actions.addElement(catalog, iri, type, label, lang));
    },
    
    onDetailElement (actions, catalog, triplet){
      return dispatch(actions.onDetailElement(triplet));
    },

    /** catalog, graph - задаются IRI элементов */
    onEmpty(actions, catalog, graph){
      return dispatch(actions.swithCatalog(catalog, graph));
    },

    onIncludeInCatalog(actions, catalog, graph, conditions){
      return dispatch(actions.includeAssetsInCatalog(catalog, graph, conditions));
    },

    onExcludeFromCatalog(actions, catalog, graph, conditions){
      return dispatch(actions.excludeAssetsFromCatalog(catalog, graph, conditions));
    },
    
    //Вызывает в WebProtegeActions созание нового проекта 
    onCreateProjectInWebProtege(action, catalog){
      return dispatch(action.createProject(catalog));
    }
  })
)(AssetListViewBase));
  
export const AssetCardView = withRouterWithHighlight(connect(
  (state, props) => {
    const { vadms, vset, vasset, vviews} = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      isSignedIn: vset.isSignedIn,
      inGroup: vset.inGroup,
      catalog: (vadms.catalog)? vadms.catalog.iri: undefined,
      IRI: vasset.iri,
      state: vasset.state,
      values: vasset.values,      //Текущие данные
      vviews,                     //Список представлений
    })
  },
  dispatch => ({
    onDeleteElement (actions, catalog, iri){
      return dispatch(actions.deleteElement(catalog, iri));
    },
    onUnlinkElement (actions, catalog, iri){
      return dispatch(actions.unlinkElement(catalog, iri));
    },
    onDetailElement (actions, catalog, triplet){
      return dispatch(actions.onDetailElement(triplet));
    },
    onReload (actions, catalog, IRI){
      return dispatch(actions.loadSelected(IRI));
    },
    onReloadViews (actions, IRI){
      return dispatch(actions.loadViews(IRI));
    },
    onAddProperty (actions, IRI, predicat, lang){
      return dispatch(actions.addProperty(IRI, predicat, lang));
    },
    onRemoveProperty(actions, IRI, predicat){
      return dispatch(actions.removeProperty(IRI, predicat));
    },
  })
)(AssetCard))

//Представление информации о ЕМД
export const EMDCardView = withRouter(connect(
  (state, props) => {
    //console.log("EMDCardView containers", props);
    const { vset, vasset, emd, vviews} = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      isSignedIn: vset.isSignedIn,
      inGroup: vset.inGroup,
      IRI: vasset.iri,
      values: vasset.values,      //Текущие данные
      state: vasset.state,
      content: emd.content,
      vviews
    })
  },
  dispatch => ({
    onReload (adms, emd, catalog, IRI){
      return Promise.all([dispatch(adms.loadSelected(IRI)), dispatch(emd.loadContent(IRI))]);
    },
    //Событие, которое загружает содержимое
    onContentSelected (actions, catalog, iri){
      if (actions)
        dispatch(actions.loadContent(NodId, repository));
    },
    onReloadViews (actions, IRI){
      return dispatch(actions.loadViews(IRI));
    },
  })
)(EMDCard))

//Представление информации о пакете информационного обмена
export const IEPCardView = withRouter(connect(
  (state, props) => {
    const { vset, vasset, emd} = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      isSignedIn: vset.isSignedIn,
      inGroup: vset.inGroup,
      IRI: vasset.iri,
      values: vasset.values,      //Текущие данные
      state: vasset.state,
            // adms: state.adms.description,
            // taxonomy: state.adms.schemas,
            // //Репозиторий для загружки содержимого пакета
            // repository: state.pie.repository,
            // asset:state.pie.selected
    })
  },
  dispatch => ({
        //Событие, которое загружает содержимое
        onReload (adms, iep, catalog, IRI){
          return Promise.all([dispatch(adms.loadSelected(IRI)), dispatch(iep.loadContent(IRI))]);
        },
  })
)(IEPCard))

export const DocsListView = connect(
    (state, props) => {
        return ({
            docs: state.docs.description,
        })
    },
    dispatch => ({
        onSelected (NodId){
        }
    })
)(DocsList)    

export const DocCardView = connect(
    (state, props) => {
        return ({
            docs: state.docs.description,
        })
    },
    null
)(DocCard)

export const EMDHistoryListView = withRouter(connect(
  (state, props) => {
    const { vset,vadms, vasset } = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,
      isSignedIn: vset.isSignedIn,
      inGroup: vset.inGroup,
      IRI: vasset.iri,
      ...vadms
    })
  },
  dispatch => ({
    onRefreshList(actions, conditions){
      //Для ADMS actions является AdmsRepository
      return dispatch(actions.loadAssets(conditions));
    },
    onSelected (IRI, history){
      history.push("/emd/"+encodeURIComponent(IRI));
    },  
  })
)(EMDHistoryList));

export const EMDHistoryCardView = withRouter(connect(
  (state, props) => {
    const { vset,vadms, vasset } = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang, 
      isSignedIn: vset.isSignedIn,
      inGroup: vset.inGroup,
      IRI: vasset.iri,
      ...vadms
    })
  },
  dispatch => ({
    onRefreshList(actions, conditions){
      //Для ADMS actions является AdmsRepository
      return dispatch(actions.loadAssets(conditions));
    },
    onSelected (IRI, navigate){
      navigate("/emd/"+encodeURIComponent(IRI));
    },  
  })
)(EMDHistoryCard));


export const XSDViewer = connect(
  (state, props) => {
      return ({
        content: state.xsd.content,
      })
  },
  null
)(XSDViewerProxy)

export const LinkerViewer = connect(
  (state, props) => {
      return ({
        linker: state.linker,
      })
  },
  null
)(LinkerCard)

export const ConceptSchemeListView = withRouter(connect(
  (state, props) => {
    const { schemes, vset } = state;
    return ({
      ...schemes, isSignedIn: vset.isSignedIn, lang: vset.lang, inGroup: vset.inGroup, sksaNamespace: vset.sksaNamespace
    })
  },
  (dispatch, ownProps) => ({

    onRefreshList(actions, conditions, lang){
      return dispatch(actions.loadSchemes(conditions, lang));
    },

    //Поиск по наименование (с учётом уже наложенных условий отбора)
    //Для SPARQL это contains(?dsn, "убл") strStarts(?dsn, "Д")
    onNameSearch (actions, pattern, conditions) {
      if (actions) { 
        const c = conditions.filter(item => !((item.predicate=="http://www.w3.org/2000/01/rdf-schema#label")&&(item.operator=="contains")));
        const filter = (!pattern)? c : c.concat({predicate: "http://www.w3.org/2000/01/rdf-schema#label", operator: "contains", value: pattern, alias:"dsn", label:pattern});
        //console.log("onNameSearch (actions, pattern, conditions)", pattern, conditions, c, filter);
        return dispatch(actions.CONDITIONS(filter));
      };
    },
    
    onSelected (IRI, actions, navigate){
      const getBaseRoutePath = ownProps.getBaseRoutePath;
      if (getBaseRoutePath) {
        navigate(getBaseRoutePath("skos/" + encodeURIComponent(IRI)));
      } else {
        navigate("/skos/"+encodeURIComponent(IRI));
      }
    },

    onAddElement (actions, iri, type, label, lang){
      return dispatch(actions.addElement(iri, type, label, lang));
    },
    
    onDetailElement (actions, catalog, triplet){
    },
    
    onInsertProperty(actions, subject, predicat, value, lang=undefined){
      return dispatch(actions.insertTriple(subject, predicat, value, lang));
    }
  })
)(ConceptSchemeList));

export const ConceptSchemeCardView = withRouter(connect(
  (state, props) => {
    const { vset, scheme, vviews, vadms} = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,      
      isSignedIn: vset.isSignedIn,
      inGroup: vset.inGroup,
      IRI: scheme.iri,
      state: scheme.state,
      values: scheme.values,          //Текущие данные
      predicates: scheme.predicates,  //Список предикатов 
      concepts: scheme.concepts,      //Список всех концептов включённых в схему
      vviews,                         //Список представлений
      catalog: vadms.catalog.iri      //IRI каталога c СА/нСД
    })
  },
  dispatch => ({
    onDeleteElement (actions, iri){
      return dispatch(actions.deleteElement(iri));
    },
    onUnlinkElement (actions, catalog, iri){
      return dispatch(actions.unlinkElement(catalog, iri));
    },
    onDetailElement (actions, catalog, triplet){
      return dispatch(actions.onDetailElement(triplet));
    },
    onReload (actions, catalog, IRI){
      return dispatch(actions.loadSelected(IRI));
    },
    onReloadViews (actions, IRI){
      return dispatch(actions.loadViews(IRI));
    },
    onReloadTaxonomy (actions, catalog, IRI){
      return dispatch(actions.loadTaxonomy(IRI));
    },
    onAddProperty (actions, IRI, predicat, lang){
      return dispatch(actions.addProperty(IRI, predicat, lang));
    },
    onRemoveProperty(actions, IRI, predicat){
      return dispatch(actions.removeProperty(IRI, predicat));
    },
    onRemoveConcept(actions, IRI){
      return dispatch(actions.deleteConcept(IRI));
    },    
    onConceptCountInScheme(actions, IRI){
      return dispatch(actions.getConceptCountInScheme(IRI));
    },
    onInScheme(actions, catalog, IRI){
      return dispatch(actions.loadConcept(IRI));
    },
    onAddConcept(actions, scheme, concept, type, label){
      return dispatch(actions.addConcept(scheme, concept, type, label));
    },
    onInsertURI(actions, subject, predicat, object){
      return dispatch(actions.insertTripleURI(subject, predicat, object));
    },
    onInsertLiteral(actions, subject, predicat, object){
      return dispatch(actions.insertTripleLiteral(subject, predicat, object));
    },
    onCountUsed(actions, IRI){
      return dispatch(actions.countThemeUsed(IRI));
    },
    //Связывает актив c каталогом
    onLinkConcept(action, schemeIRI, conceptIRI){
      return dispatch(action.linkConcept(schemeIRI, conceptIRI));
    },
    //Используется в графах
    onInGraph(action, schemeIRI){
      return dispatch(action.inGraph(schemeIRI));
    }

  })
)(ConceptSchemeCard))

/***************************************************************************************************/
//                 V     V  OOOO    CCCC    AAAA    BBBBB    SSSS   
//                 V     V O    O  C    C  A    A   B    B  S    S
//                  V   V  O    O  C       A    A  B    B  S
//                  V   V  O    O  C       A    A  BBBBB    SSSS
//                   V V   O    O  C       AAAAAA  B    B       S
//                   V V   O    O  C    C  A    A  B    B  S    S
//                    V     OOOO    CCCC   A    A  BBBBB    SSSS
/***************************************************************************************************/

export const ValuesVocabsListView = withRouterWithHighlight(connect(
  (state, props) => {
    const { vocabs, vset } = state;
    return ({
      ...vocabs, isSignedIn: vset.isSignedIn, lang: vset.lang, inGroup: vset.inGroup, sksaNamespace: vset.sksaNamespace
    })
  },
  (dispatch, ownProps) => ({

    onRefreshList(actions, conditions, rdfTypes, lang){      
      return dispatch(actions.loadVocabs(conditions, rdfTypes, lang));
    },

    onChangeConditions (actions, conditions) {
      if (actions) 
        return dispatch(actions.CONDITIONS(conditions));
    },
    
    //Поиск по наименование (с учётом уже наложенных условий отбора)
    //Для SPARQL это contains(?dsn, "убл") strStarts(?dsn, "Д")
    onNameSearch (actions, pattern, conditions) {
      if (actions) { 
        const c = conditions.filter(item => !((item.predicate=="http://www.w3.org/2000/01/rdf-schema#label")&&(item.operator=="contains")));
        const filter = (!pattern)? c : c.concat({predicate: "http://www.w3.org/2000/01/rdf-schema#label", operator: "contains", value: pattern, alias:"dsn", label:pattern});
        //console.log("onNameSearch (actions, pattern, conditions)", pattern, conditions, c, filter);
        return dispatch(actions.CONDITIONS(filter));
      };
    },
    
    onSelected (IRI, actions, navigate){
      const getBaseRoutePath = ownProps.getBaseRoutePath;
      if (getBaseRoutePath) {
        navigate(getBaseRoutePath("individual/" + encodeURIComponent(IRI)));
      } else {
        navigate("/individual/"+encodeURIComponent(IRI));
      }
    },

    onAddElement (actions, iri, type, label, lang){
      return dispatch(actions.addElement(iri, type, label, lang));
    },
    
    onDetailElement (actions, catalog, triplet){
    },
  })
)(ValuesVocabsList));

export const IndividualCardView = withRouter(connect(
  (state, props) => {
    const { vset, vindivid, vviews} = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,      
      isSignedIn: vset.isSignedIn,
      inGroup: vset.inGroup,
      IRI: vindivid.iri,
      state: vindivid.state,
      values: vindivid.values,          //Текущие данные
      predicates: vindivid.predicates,  //Список предикатов 
      vviews,                         //Список представлений
    })
  },
  dispatch => ({
    onDeleteElement (actions, iri){
      return dispatch(actions.deleteElement(iri));
    },
    onUnlinkElement (actions, catalog, iri){
      return dispatch(actions.unlinkElement(catalog, iri));
    },
    onDetailElement (actions, catalog, triplet){
      return dispatch(actions.onDetailElement(triplet));
    },
    onReload (actions, IRI){
      return dispatch(actions.loadSelected(IRI));
    },
    onReloadViews (actions, IRI){
      return dispatch(actions.loadViews(IRI));
    },
    onReloadTaxonomy (actions, catalog, IRI){
      return dispatch(actions.loadTaxonomy(IRI));
    },
    onAddProperty (actions, IRI, predicat, lang){
      return dispatch(actions.addProperty(IRI, predicat, lang));
    },
    onRemoveProperty(actions, IRI, predicat){
      return dispatch(actions.removeProperty(IRI, predicat));
    },
    onRemoveConcept(actions, IRI){
      return dispatch(actions.deleteConcept(IRI));
    },    
    onConceptCountInScheme(actions, IRI){
      return dispatch(actions.getConceptCountInScheme(IRI));
    },
    onInScheme(actions, catalog, IRI){
      return dispatch(actions.loadConcept(IRI));
    },
    onAddConcept(actions, scheme, concept, type, label){
      return dispatch(actions.addConcept(scheme, concept, type, label));
    },
    onInsertURI(actions, subject, predicat, object){
      return dispatch(actions.insertTripleURI(subject, predicat, object));
    },
    onInsertLiteral(actions, subject, predicat, object){
      return dispatch(actions.insertTripleLiteral(subject, predicat, object));
    },
    
  })
)(IndividualCard))

/************************************************************************************************** */
//                  SSSS   U    U  BBBB      JJJ  EEEEE   CCCC  TTTTT
//                 S    S  U    U  B   B      J   E      C        T
//                 S       U    U  B   B      J   E      C        T
//                  SSSS   U    U  BBBB       J   EEEE   C        T
//                      S  U    U  B   B      J   E      C        T
//                 S    S  U    U  B   B  J   J   E      C        T
//                  SSSS    UUUU   BBBB    JJJ    EEEEE   CCCC    T
/************************************************************************************************** */
//Представление списка субъеутов к графе, на основе заданного IRI объекта 
export const SubjectListView = withRouter(connect(
  (state, props) => {
    const { subjects, vset } = state;
    return ({
      ...subjects, 
      isSignedIn: vset.isSignedIn, 
      lang: vset.lang,
      rfilter: props.rfilter ?? subjects.rfilter,
      inGroup: vset.inGroup
    })
  },
  dispatch => ({
    onRefreshList(actions, iri, conditions){
      return dispatch(actions.loadSubjects(iri, conditions));
    },
    
    onChangeConditions (actions, conditions) {
      if (actions) 
        return dispatch(actions.CONDITIONS(conditions));
    },

    //Поиск по наименование (с учётом уже наложенных условий отбора)
    //Для SPARQL это contains(?dsn, "убл") strStarts(?dsn, "Д")
    onNameSearch (actions, pattern, conditions) {
      if (actions) { 
        const c = conditions.filter(item => !((item.predicate=="http://www.w3.org/2000/01/rdf-schema#label")&&(item.operator=="contains")));
        const filter = (!pattern)? c : c.concat({predicate: "http://www.w3.org/2000/01/rdf-schema#label", operator: "contains", value: pattern, alias:"dsn", label:pattern});
        //console.log("onNameSearch (actions, pattern, conditions)", pattern, conditions, c, filter);
        return dispatch(actions.CONDITIONS(filter)); //loadAssets(filter));
      };
    },
  })
)(SubjectList));

/** Произвольная информация об субъекте. 
 * С подсветкой строки с нужным свойством  */
export const SubjectCardView = withRouterWithHighlight(connect(
  (state, props) => {
    const { vset, vindivid, vviews} = state;
    const { lang } = props;
    return ({
      lang: (lang)?lang: vset.lang,      
      isSignedIn: vset.isSignedIn,
      inGroup: vset.inGroup,
      IRI: vindivid.iri,
      state: vindivid.state,
      values: vindivid.values,          //Текущие данные
      predicates: vindivid.predicates,  //Список предикатов 
      vviews,                         //Список представлений
    })
  },
  dispatch => ({
    onDetailElement (actions, catalog, triplet){
      return dispatch(actions.onDetailElement(triplet));
    },
    onReload (actions, IRI){
      return dispatch(actions.loadSelected(IRI));
    },
    onReloadViews (actions, IRI){
      return dispatch(actions.loadViews(IRI));
    },
    onLoadNodes (actions, nodeID){
      return actions.loadSubject(nodeID);
    },
    onAddNodes (actions, nodes, contents){
      return dispatch(actions.ADD_NODES(nodes, contents));
    },
  })
)(SubjectCard))

/************************************************************************************************** */
//                  CCCC     A     TTTTT    A     L       OOO    GGGG
//                 C        A A      T     A A    L      O   O  G
//                 C       A   A     T    A   A   L      O   O  G
//                 C       AAAAA     T    AAAAA   L      O   O  G  GG
//                 C       A   A     T    A   A   L      O   O  G   G
//                 C       A   A     T    A   A   L      O   O  G   G
//                  CCCC   A   A     T    A   A   LLLLL   OOO    GGG
/************************************************************************************************** */
export const SKSAOntologyView = withRouter(connect(
  (state, props) => {
    const { vowl, vset, vselected } = state;
    return ({
      ...vowl,
      vselected,
      lang: vset.lang,
      isSignedIn: vset.isSignedIn,
      inGroup: vset.inGroup,
    });
  },
  dispatch => ({
    onLoadTrees() {
      return dispatch(OwlRepository.loadTrees());
    },

    onExportOntology() {
      return dispatch(OwlRepository.loadOntology());
    },

    onSelectElement(iri, router) {
      dispatch(OwlRepository.SELECT_TREE_ELEMENT(iri));
      if (router && router.location && router.navigate) {
        const pathname = router.location.pathname || '';
        const search = router.location.search || '';
        router.navigate(`${pathname}${search}#${encodeURIComponent(iri)}`, {replace: true});
      }
      return dispatch(OwlRepository.loadTreeElementDetails(iri));
    },

    onReloadEntity(iri) {
      return Promise.all([
        dispatch(OwlRepository.loadTreeElementDetails(iri)),
        dispatch(OwlRepository.loadTrees()),
      ]);
    },

    onSaveEntity(iri, values, details) {
      const label = values ? values.label : undefined;
      if (!iri || typeof label === "undefined")
        return Promise.resolve({iri, values, details});

      const outgoing = details && Array.isArray(details.outgoing) ? details.outgoing : [];
      const labelBinding = outgoing.find(item =>
        item.predicat && item.predicat.value === RDFS_LABEL
        && item.object
        && item.object.type === "literal"
        && !item.object["xml:lang"]
      );
      const oldLabel = labelBinding && labelBinding.object ? labelBinding.object.value : undefined;

      const operation = (typeof oldLabel === "undefined")
        ? dispatch(RdfTriplet.insertTripleLiteral(iri, RDFS_LABEL, label))
        : (oldLabel === label)
          ? Promise.resolve({iri, label})
          : dispatch(RdfTriplet.updateLiteralSimple(iri, RDFS_LABEL, oldLabel, label));

      return operation.then(() => Promise.all([
        dispatch(OwlRepository.loadTreeElementDetails(iri)),
        dispatch(OwlRepository.loadTrees()),
      ]));
    },
  })
)(SKSAOntology));

/** Админ интерфейс для настройки каталога  */
export const AdminInterfaceLandingView = withRouter(connect(
  (state, props) => {
    const { vset } = state;
    return ({
      isSignedIn: vset.isSignedIn, 
      lang: vset.lang,
      inGroup: vset.inGroup
    })
  },
  dispatch => ({
  })
)(AdminInterfaceLanding));



export const SKSACatalogListView = withRouterWithHighlight(connect(
  (state, props) => {
    const { vcatalogs, vset } = state;
    return ({
      ...vcatalogs, isSignedIn: vset.isSignedIn, lang: vset.lang, inGroup: vset.inGroup, sksaNamespace: vset.sksaNamespace
    })
  },
  dispatch => ({

    onRefreshList(actions, conditions, lang){
      return Promise.all([
        dispatch(actions.loadGraphs()),
        dispatch(actions.loadCatalogs(conditions, lang)),
      ]);
    },
    
    onChangeConditions (actions, conditions) {
      if (actions) 
        return dispatch(actions.CONDITIONS(conditions));
    },

    onSelected (catalog, graph, actions, navigate){
      navigate("/catalog/"+encodeURIComponent(catalog)+"/"+encodeURIComponent(graph));
    },

    onAddElement (actions, iri, type, label, lang){
      return dispatch(actions.addElement(iri, type, label, lang));
    },
    
    onDetailElement (actions, catalog, triplet){
    },
    
    onInsertProperty(actions, subject, predicat, value, lang=undefined){
      return dispatch(actions.insertTriple(subject, predicat, value, lang));
    }
  })
)(SKSACatalogList));


export const SKSACatalogCardView = withRouter(connect(
  (state, props) => {
    const { vcatalog, vset } = state;
    return ({
      isSignedIn: vset.isSignedIn, lang: vset.lang, inGroup: vset.inGroup, sksaNamespace: vset.sksaNamespace
    })
  },
  dispatch => ({
  })
)(SKSACatalogCard));


export const NamespaceListView = withRouter(connect(
  (state, props) => {
    const { vset } = state;
    return ({
      namespaces: vset.xmlns,
      isSignedIn: vset.isSignedIn, 
      inGroup: vset.inGroup, sksaNamespace: vset.sksaNamespace,
      lang: vset.lang
    })
  },
  dispatch => ({
    onRefreshList(actions){
      return dispatch(actions.loadNamespaces());
    },
    onAddNamespace(namespace, uri) {
      return dispatch(SettingsAction.addNamespace(namespace, uri));
    },
  })
)(NamespaceList));
